function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object, status) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-fb-btn-animate-buttons': status === $component.states.marked,
          'mp-fb-btn-animate-thank-you': status === $component.states.thanks,
        }, {
          'mp-fb-btn-feedback': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!($attr(`disable`) && status === $component.states.notSent)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((((status) == ($component.states.notSent)) || ((status) == ($component.states.marked))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: ev => $helpers.handleSentFeedback(ev, false)
                },
                "class": {
                  'mp-fb-btn-option': true,
                  'mp-fb-btn-bad': true,
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-fb-btn-icon': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: 'thumbs-down'
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-fb-btn-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Not useful");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: ev => $helpers.handleSentFeedback(ev, true)
                },
                "class": {
                  'mp-fb-btn-option': true,
                  'mp-fb-btn-good': true,
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-fb-btn-icon': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: 'thumbs-up'
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-fb-btn-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Useful");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) :
            (((status) == ($component.states.thanks))) ?
            ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-fb-btn-thank-you': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Thank you for your feedback");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) :
            undefined);;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "status" in locals ? locals.status : typeof status !== "undefined" ? status : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;